import * as type from "./type";

const initialState = {
  getVendorLogs: null,
  deleteVendorLog: null,
};

const AdminVendorLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_VENDOR_LOG_LIST_REQUEST:
      return { ...state, getVendorLogs: null };
    case type.GET_VENDOR_LOG_LIST_SUCCESS:
      return { ...state, getVendorLogs: action.payload };
    case type.DELETE_VENDOR_LOG_REQUEST:
      return { ...state, deleteVendorLog: null };
    case type.DELETE_VENDOR_LOG_SUCCESS:
      return { ...state, deleteVendorLog: action.payload };
    case type.CLEAR_VENDOR_LOG_LIST:
      return { ...state, getVendorLogs: null, deleteVendorLog: null };
    default:
      return {
        ...state,
      };
  }
};
export default AdminVendorLogReducer;
